(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ab-about-editorial"] && !Shopify.designMode) return;
  try {
    

/*
  AYURVEDA BHARAT — ABOUT STATISTICS

  Animates numerical values once when visible.
  Keeps editorial content static.

  Non-numeric values remain unchanged.
  Values remain visible when JS is unavailable.
*/

(() => {

  const selector = '[data-abao]';

  function initialize(section) {

    if (!section || section.dataset.abaoReady === 'true') {
      return;
    }

    section.dataset.abaoReady = 'true';

    const strip = section.querySelector(
      '.abao__statistics'
    );

    if (!strip) return;

    const counters = Array.from(
      strip.querySelectorAll('[data-abao-counter]')
    );

    if (!counters.length) return;

    const reduceMotion = window.matchMedia(
      '(prefers-reduced-motion: reduce)'
    ).matches;

    if (reduceMotion) return;

    function startAnimation() {

      if (strip.dataset.animated === 'true') {
        return;
      }

      strip.dataset.animated = 'true';

      const items = counters.map(element => {

        const original = element.dataset.target.trim();
        const normalized = original.replace(/,/g, '');

        const isNumeric = /^\d+(\.\d+)?$/.test(normalized);

        const decimals = normalized.includes('.')
          ? normalized.split('.')[1].length
          : 0;

        const integerPart = normalized.split('.')[0];

        const preserveZeros =
          integerPart.length > 1 &&
          integerPart.startsWith('0');

        return {
          element,
          original,
          target: isNumeric ? Number(normalized) : null,
          decimals,
          preserveZeros,
          padding: integerPart.length,
          formatted: original.includes(',')
        };

      });

      const duration = 1100;
      let startTime = null;

      function animate(timestamp) {

        if (startTime === null) {
          startTime = timestamp;
        }

        const progress = Math.min(
          1,
          (timestamp - startTime) / duration
        );

        const eased = 1 - Math.pow(1 - progress, 3);

        items.forEach(item => {

          if (item.target === null) {
            item.element.textContent = item.original;
            return;
          }

          const current = item.target * eased;

          let formatted = current.toFixed(item.decimals);

          if (item.preserveZeros) {

            const parts = formatted.split('.');

            parts[0] = parts[0].padStart(
              item.padding,
              '0'
            );

            formatted = parts.join('.');

          } else if (item.formatted && item.decimals === 0) {

            formatted = Math.round(current)
              .toLocaleString('en-IN');

          }

          item.element.textContent = formatted;

        });

        if (progress < 1) {

          requestAnimationFrame(animate);

        } else {

          items.forEach(item => {
            item.element.textContent = item.original;
          });

        }

      }

      requestAnimationFrame(animate);

    }

    if (!('IntersectionObserver' in window)) {
      startAnimation();
      return;
    }

    const observer = new IntersectionObserver(
      entries => {

        if (entries.some(entry => entry.isIntersecting)) {
          observer.disconnect();
          startAnimation();
        }

      },
      { threshold: 0.2 }
    );

    observer.observe(strip);

  }

  function initializeAll(root = document) {

    if (root.matches?.(selector)) {
      initialize(root);
    }

    root.querySelectorAll?.(selector)
      .forEach(initialize);

  }

  if (document.readyState === 'loading') {

    document.addEventListener(
      'DOMContentLoaded',
      () => initializeAll(),
      { once: true }
    );

  } else {

    initializeAll();

  }

  document.addEventListener(
    'shopify:section:load',
    event => initializeAll(event.target)
  );

})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ab-article-detail"] && !Shopify.designMode) return;
  try {
    

(() => {

  /*
    ==========================================
    AYURVEDA BHARAT — TABLE OF CONTENTS

    - Generates TOC from article H2/H3
    - Assigns unique heading IDs
    - Highlights heading nearest top
    - Uses native anchor navigation
    - Does NOT navigate or reload on scroll
    - Does NOT scroll the page automatically
    - Handles Shopify theme editor updates
    ==========================================
  */

  const SELECTOR = '[data-aba-article]';

  const instances = new Map();

  let scheduled = false;

  /* ======================================
     CREATE TABLE OF CONTENTS
  ====================================== */

  function initialize(section) {

    if (!section) return;

    if (section.dataset.abaInitialized === 'true') {
      return;
    }

    const content = section.querySelector(
      '[data-aba-content]'
    );

    const toc = section.querySelector(
      '[data-aba-toc]'
    );

    const tocList = section.querySelector(
      '[data-aba-toc-list]'
    );

    if (!content) return;

    section.dataset.abaInitialized = 'true';

    const headings = Array.from(
      content.querySelectorAll('h2, h3')
    ).filter(heading => heading.textContent.trim());

    const links = [];

    if (toc && tocList && headings.length) {

      tocList.replaceChildren();

      const usedIds = new Set();

      headings.forEach((heading, index) => {

        /*
          Preserve existing heading IDs when
          present, otherwise generate unique IDs.
        */

        if (!heading.id) {

          const slug = heading.textContent
            .trim()
            .toLowerCase()
            .normalize('NFKD')
            .replace(/[\u0300-\u036f]/g, '')
            .replace(/[^a-z0-9\s-]/g, '')
            .replace(/\s+/g, '-')
            .replace(/-+/g, '-')
            .replace(/^-|-$/g, '');

          const baseId =
            section.id +
            '-' +
            (slug || 'heading-' + (index + 1));

          let finalId = baseId;
          let suffix = 2;

          while (
            usedIds.has(finalId) ||
            document.getElementById(finalId)
          ) {

            finalId = baseId + '-' + suffix;
            suffix++;

          }

          heading.id = finalId;

        }

        usedIds.add(heading.id);

        /* LIST ITEM */

        const item = document.createElement('li');

        item.className = 'aba-toc__item';

        if (heading.tagName === 'H3') {
          item.classList.add('aba-toc__item--sub');
        }

        /* LINK */

        const link = document.createElement('a');

        link.className = 'aba-toc__link';

        link.href = '#' + encodeURIComponent(heading.id);

        link.textContent = heading.textContent.trim();

        item.appendChild(link);

        tocList.appendChild(item);

        links.push(link);

      });

      toc.hidden = false;

    } else if (toc) {

      toc.hidden = true;

    }

    instances.set(section, {
      headings,
      links
    });

    updateActive(section);

  }

  /* ======================================
     UPDATE ACTIVE HEADING
  ====================================== */

  function updateActive(section) {

    const instance = instances.get(section);

    if (!instance) return;

    if (!section.isConnected) {
      instances.delete(section);
      return;
    }

    const { headings, links } = instance;

    if (!headings.length) return;

    const activationLine = Math.min(
      190,
      window.innerHeight * .28
    );

    let activeIndex = 0;

    headings.forEach((heading, index) => {

      const rect = heading.getBoundingClientRect();

      if (rect.top <= activationLine) {
        activeIndex = index;
      }

    });

    links.forEach((link, index) => {

      const active = index === activeIndex;

      link.classList.toggle(
        'is-active',
        active
      );

      if (active) {
        link.setAttribute('aria-current', 'location');
      } else {
        link.removeAttribute('aria-current');
      }

    });

  }

  /* ======================================
     UPDATE ALL SECTIONS
  ====================================== */

  function updateAll() {

    scheduled = false;

    instances.forEach((value, section) => {

      updateActive(section);

    });

  }

  function requestUpdate() {

    if (scheduled) return;

    scheduled = true;

    window.requestAnimationFrame(updateAll);

  }

  /* ======================================
     INITIALIZE ALL
  ====================================== */

  function initializeAll(root = document) {

    if (
      root.matches &&
      root.matches(SELECTOR)
    ) {
      initialize(root);
    }

    root.querySelectorAll(SELECTOR)
      .forEach(initialize);

    requestUpdate();

  }

  /* ======================================
     CLEANUP
  ====================================== */

  function cleanup(root) {

    instances.forEach((value, section) => {

      if (
        root === section ||
        root.contains(section)
      ) {

        delete section.dataset.abaInitialized;

        instances.delete(section);

      }

    });

  }

  /* ======================================
     PAGE EVENTS
  ====================================== */

  window.addEventListener(
    'scroll',
    requestUpdate,
    { passive: true }
  );

  window.addEventListener(
    'resize',
    requestUpdate,
    { passive: true }
  );

  window.addEventListener(
    'pageshow',
    requestUpdate
  );

  /* ======================================
     INITIAL PAGE LOAD
  ====================================== */

  if (document.readyState === 'loading') {

    document.addEventListener(
      'DOMContentLoaded',
      () => initializeAll(document),
      { once: true }
    );

  } else {

    initializeAll(document);

  }

  /* ======================================
     SHOPIFY THEME EDITOR
  ====================================== */

  document.addEventListener(
    'shopify:section:load',
    event => {

      initializeAll(event.target);

    }
  );

  document.addEventListener(
    'shopify:section:unload',
    event => {

      cleanup(event.target);

    }
  );

  document.addEventListener(
    'shopify:section:select',
    event => {

      initializeAll(event.target);

    }
  );

})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ab-business-journey"] && !Shopify.designMode) return;
  try {
    

(() => {

  /*
    AYURVEDA BHARAT — BUSINESS JOURNEY

    IMPORTANT FIX:

    No automatic active states.
    No scroll-based marker highlighting.
    No green progress fill.

    JavaScript only handles subtle
    fade-up entrance for step content.

    Circle backgrounds change ONLY
    through CSS hover.
  */

  const SELECTOR = '[data-abj]';

  const observers = new WeakMap();

  /* ====================================
     INITIALIZE ONE SECTION
  ==================================== */

  function initialize(section) {

    if (!section) return;

    if (section.dataset.abjInitialized === 'true') {
      return;
    }

    const steps = Array.from(
      section.querySelectorAll('[data-abj-step]')
    );

    if (!steps.length) return;

    section.dataset.abjInitialized = 'true';

    const reducedMotion = window.matchMedia(
      '(prefers-reduced-motion: reduce)'
    ).matches;

    if (
      reducedMotion ||
      !('IntersectionObserver' in window)
    ) {

      steps.forEach(step => {
        step.classList.add('is-revealed');
      });

      return;

    }

    /* OBSERVE STEP ENTRANCE */

    const observer = new IntersectionObserver(
      entries => {

        entries.forEach(entry => {

          if (!entry.isIntersecting) return;

          entry.target.classList.add(
            'is-revealed'
          );

          observer.unobserve(entry.target);

        });

      },
      {
        threshold: 0.12
      }
    );

    steps.forEach(step => {
      observer.observe(step);
    });

    observers.set(section, observer);

  }

  /* ====================================
     INITIALIZE ALL SECTIONS
  ==================================== */

  function initializeAll(root = document) {

    if (
      root.matches &&
      root.matches(SELECTOR)
    ) {
      initialize(root);
    }

    root.querySelectorAll(SELECTOR)
      .forEach(initialize);

  }

  /* ====================================
     INITIAL PAGE LOAD
  ==================================== */

  if (document.readyState === 'loading') {

    document.addEventListener(
      'DOMContentLoaded',
      () => initializeAll(document),
      { once: true }
    );

  } else {

    initializeAll(document);

  }

  /* ====================================
     SHOPIFY SECTION RELOAD
  ==================================== */

  document.addEventListener(
    'shopify:section:load',
    event => {

      initializeAll(event.target);

    }
  );

  /* ====================================
     SHOPIFY SECTION UNLOAD
  ==================================== */

  document.addEventListener(
    'shopify:section:unload',
    event => {

      const sections = [];

      if (
        event.target.matches &&
        event.target.matches(SELECTOR)
      ) {
        sections.push(event.target);
      }

      event.target.querySelectorAll(SELECTOR)
        .forEach(section => {
          sections.push(section);
        });

      sections.forEach(section => {

        const observer = observers.get(section);

        if (observer) {
          observer.disconnect();
          observers.delete(section);
        }

        delete section.dataset.abjInitialized;

      });

    }
  );

  /* ====================================
     SHOPIFY SECTION SELECT
  ==================================== */

  document.addEventListener(
    'shopify:section:select',
    event => {

      initializeAll(event.target);

    }
  );

})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ab-related-products"] && !Shopify.designMode) return;
  try {
    

(() => {

  /*
    AYURVEDA BHARAT
    RELATED PRODUCTS INITIALIZATION

    Load related products using Shopify's
    Product Recommendations API.

    The HTML returned by Shopify includes
    our reusable ab-product-card snippet.
  */

  const SELECTOR = '[data-ab-related]';

  /* ====================================
     LOAD RECOMMENDATIONS
  ==================================== */

  async function loadRecommendations(section) {

    if (!section) return;

    if (section.dataset.loaded === 'true') return;

    if (section.dataset.loading === 'true') return;

    const url = section.dataset.url;

    if (!url) return;

    section.dataset.loading = 'true';

    try {

      const response = await fetch(url, {
        credentials: 'same-origin'
      });

      if (!response.ok) {
        throw new Error(
          'Recommendation request failed: ' + response.status
        );
      }

      const html = await response.text();

      const documentFragment = new DOMParser()
        .parseFromString(html, 'text/html');

      const newSection = documentFragment.querySelector(
        SELECTOR
      );

      if (!newSection) return;

      const newGrid = newSection.querySelector(
        '[data-ab-related-grid]'
      );

      if (!newGrid) return;

      const cards = newGrid.querySelectorAll(
        '.ab-related__item'
      );

      if (!cards.length) return;

      const originalContainer = section.querySelector(
        '[data-ab-related-content]'
      );

      const newContainer = newSection.querySelector(
        '[data-ab-related-content]'
      );

      if (!originalContainer || !newContainer) {
        return;
      }

      /* INSERT RECOMMENDED PRODUCTS */

      originalContainer.innerHTML =
        newContainer.innerHTML;

      /* REVEAL SECTION */

      section.dataset.loaded = 'true';

      /* CUSTOM EVENT FOR EXISTING CARD SCRIPTS */

      section.dispatchEvent(
        new CustomEvent('ab:related-products:loaded', {
          bubbles: true
        })
      );

    } catch (error) {

      console.error(
        'Ayurveda Bharat related products:',
        error
      );

    } finally {

      section.dataset.loading = 'false';

    }

  }

  /* ====================================
     INITIALIZE
  ==================================== */

  function initialize(root = document) {

    if (
      root.matches &&
      root.matches(SELECTOR)
    ) {
      loadRecommendations(root);
    }

    root.querySelectorAll(SELECTOR)
      .forEach(loadRecommendations);

  }

  /* ====================================
     PAGE LOAD
  ==================================== */

  if (document.readyState === 'loading') {

    document.addEventListener(
      'DOMContentLoaded',
      () => initialize(document),
      { once: true }
    );

  } else {

    initialize(document);

  }

  /* ====================================
     SHOPIFY THEME EDITOR
  ==================================== */

  document.addEventListener(
    'shopify:section:load',
    event => {

      initialize(event.target);

    }
  );

  document.addEventListener(
    'shopify:section:select',
    event => {

      initialize(event.target);

    }
  );

})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ayurveda-about-us"] && !Shopify.designMode) return;
  try {
    

(() => {

  /*
    AYURVEDA BHARAT — COUNTER ANIMATION

    The editorial paragraph has no animation.

    Counters animate once when the
    statistics panel enters the viewport.

    Numbers remain visible by default
    if JavaScript does not execute.
  */

  const SECTION_SELECTOR = '[data-ab-about-white]';

  const reducedMotion = window.matchMedia(
    '(prefers-reduced-motion: reduce)'
  );

  const observers = new WeakMap();

  const clamp = (value, min = 0, max = 1) => {
    return Math.min(max, Math.max(min, value));
  };

  const easeOut = value => {
    const p = clamp(value);
    return 1 - Math.pow(1 - p, 3);
  };

  /* ====================================
     NUMBER FORMATTING
  ==================================== */

  function formatCounter(original, value) {

    const input = String(original || '0').trim();

    const normalized = input.replace(/,/g, '');

    const target = Number(normalized);

    if (!Number.isFinite(target)) {
      return input;
    }

    const decimalPart = normalized.split('.')[1];

    const decimalPlaces = decimalPart
      ? Math.min(decimalPart.length, 2)
      : 0;

    let result = decimalPlaces > 0
      ? value.toFixed(decimalPlaces)
      : String(Math.round(value));

    const originalInteger = normalized.split('.')[0];

    /*
      Preserve formats like:
      01, 02, 03.
    */

    if (/^0\d+/.test(originalInteger)) {

      const pieces = result.split('.');

      pieces[0] = pieces[0].padStart(
        originalInteger.length,
        '0'
      );

      result = pieces.join('.');

    }

    return result;

  }

  /* ====================================
     START COUNTERS
  ==================================== */

  function startCounters(section) {

    const panel = section.querySelector(
      '[data-abw-panel]'
    );

    if (!panel) return;

    if (panel.dataset.abwStarted === 'true') {
      return;
    }

    panel.dataset.abwStarted = 'true';

    const counters = Array.from(
      panel.querySelectorAll('[data-abw-counter]')
    );

    if (!counters.length) return;

    if (reducedMotion.matches) {
      counters.forEach(counter => {
        counter.textContent = counter.dataset.target || '0';
      });
      return;
    }

    const targets = counters.map(counter => {

      const original = counter.dataset.target || '0';

      const numeric = Number(
        original.replace(/,/g, '')
      );

      return {
        element: counter,
        original: original,
        numeric: Number.isFinite(numeric)
          ? numeric
          : null
      };

    });

    const duration = 1250;

    let startTime = null;

    function animate(timestamp) {

      if (startTime === null) {
        startTime = timestamp;
      }

      const progress = clamp(
        (timestamp - startTime) / duration
      );

      const eased = easeOut(progress);

      targets.forEach(item => {

        if (item.numeric === null) {
          item.element.textContent = item.original;
          return;
        }

        const current = item.numeric * eased;

        item.element.textContent = formatCounter(
          item.original,
          current
        );

      });

      if (progress < 1) {

        requestAnimationFrame(animate);

      } else {

        targets.forEach(item => {
          item.element.textContent = item.original;
        });

      }

    }

    requestAnimationFrame(animate);

  }

  /* ====================================
     INITIALIZE ONE SECTION
  ==================================== */

  function initialize(section) {

    if (!section) return;

    const panel = section.querySelector(
      '[data-abw-panel]'
    );

    if (!panel) return;

    if (panel.dataset.abwObserved === 'true') {
      return;
    }

    panel.dataset.abwObserved = 'true';

    if (!('IntersectionObserver' in window)) {

      startCounters(section);
      return;

    }

    const observer = new IntersectionObserver(
      entries => {

        entries.forEach(entry => {

          if (!entry.isIntersecting) return;

          startCounters(section);

          observer.disconnect();

        });

      },
      {
        threshold: 0.1
      }
    );

    observer.observe(panel);

    observers.set(section, observer);

  }

  /* ====================================
     INITIALIZE ALL SECTIONS
  ==================================== */

  function initializeAll(root = document) {

    if (
      root.matches &&
      root.matches(SECTION_SELECTOR)
    ) {
      initialize(root);
    }

    root.querySelectorAll(SECTION_SELECTOR)
      .forEach(initialize);

  }

  /* ====================================
     INITIAL PAGE LOAD
  ==================================== */

  if (document.readyState === 'loading') {

    document.addEventListener(
      'DOMContentLoaded',
      () => initializeAll(document),
      { once: true }
    );

  } else {

    initializeAll(document);

  }

  /* ====================================
     SHOPIFY THEME EDITOR
  ==================================== */

  document.addEventListener(
    'shopify:section:load',
    event => {

      initializeAll(event.target);

    }
  );

  document.addEventListener(
    'shopify:section:select',
    event => {

      initializeAll(event.target);

    }
  );

  document.addEventListener(
    'shopify:section:unload',
    event => {

      const sections = [];

      if (
        event.target.matches &&
        event.target.matches(SECTION_SELECTOR)
      ) {
        sections.push(event.target);
      }

      event.target.querySelectorAll(SECTION_SELECTOR)
        .forEach(section => sections.push(section));

      sections.forEach(section => {

        const observer = observers.get(section);

        if (observer) {
          observer.disconnect();
        }

      });

    }
  );

})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ayurveda-categories"] && !Shopify.designMode) return;
  try {
    

/*
  Ayurveda Bharat Collection Carousel

  - Arrow navigation
  - Scroll button states
  - Keyboard and touch friendly
  - Works after Shopify theme editor reloads
*/

(function () {

  function updateArrows(section) {

    if (!section) return;

    const track = section.querySelector(
      '[data-ab-cat-track]'
    );

    if (!track) return;

    const prev = section.querySelector(
      '[data-ab-cat-arrow="-1"]'
    );

    const next = section.querySelector(
      '[data-ab-cat-arrow="1"]'
    );

    if (!prev || !next) return;

    const current = track.scrollLeft;

    const maxScroll =
      track.scrollWidth - track.clientWidth;

    prev.disabled = current <= 2;

    next.disabled = current >= maxScroll - 2;

  }

  function initializeArrows(scope) {

    const sections = [];

    if (
      scope.matches &&
      scope.matches('[data-ab-collection-section]')
    ) {
      sections.push(scope);
    }

    scope.querySelectorAll(
      '[data-ab-collection-section]'
    ).forEach(section => {
      sections.push(section);
    });

    sections.forEach(section => {
      updateArrows(section);
    });

  }

  /* INITIALIZE */

  if (document.readyState === 'loading') {

    document.addEventListener(
      'DOMContentLoaded',
      () => initializeArrows(document)
    );

  } else {

    initializeArrows(document);

  }

  /* ARROW CLICKS */

  document.addEventListener('click', event => {

    const button = event.target.closest(
      '[data-ab-cat-arrow]'
    );

    if (!button || button.disabled) return;

    const section = button.closest(
      '[data-ab-collection-section]'
    );

    if (!section) return;

    const track = section.querySelector(
      '[data-ab-cat-track]'
    );

    if (!track) return;

    const firstCard = track.querySelector(
      '[data-ab-category-card]'
    );

    if (!firstCard) return;

    const cardWidth =
      firstCard.getBoundingClientRect().width;

    const styles = window.getComputedStyle(track);

    const gap = parseFloat(
      styles.columnGap || styles.gap
    ) || 0;

    const direction = Number(
      button.dataset.abCatArrow
    );

    const prefersReducedMotion =
      window.matchMedia(
        '(prefers-reduced-motion: reduce)'
      ).matches;

    track.scrollBy({
      left: direction * (cardWidth + gap),
      behavior: prefersReducedMotion
        ? 'auto'
        : 'smooth'
    });

  });

  /* UPDATE ARROWS AS USERS SCROLL */

  document.addEventListener(
    'scroll',
    event => {

      const track = event.target;

      if (
        !track.matches ||
        !track.matches('[data-ab-cat-track]')
      ) {
        return;
      }

      const section = track.closest(
        '[data-ab-collection-section]'
      );

      updateArrows(section);

    },
    true
  );

  /* RESPOND TO WINDOW RESIZING */

  window.addEventListener('resize', () => {

    document.querySelectorAll(
      '[data-ab-collection-section]'
    ).forEach(section => {

      updateArrows(section);

    });

  }, { passive: true });

  /* SHOPIFY THEME EDITOR SUPPORT */

  document.addEventListener(
    'shopify:section:load',
    event => {

      initializeArrows(event.target);

    }
  );

})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ayurveda-concerns"] && !Shopify.designMode) return;
  try {
    

(() => {

  /*
    AYURVEDA BHARAT — CONCERNS

    - Dynamic collection tabs
    - Product carousel navigation
    - Fixed three-slot preview system
    - Smooth sliding animations
    - AJAX Add to Cart
    - Horizon cart drawer support
    - Shopify theme editor support
  */

  const SELECTOR = '[data-abconc]';

  const reducedMotion = window.matchMedia(
    '(prefers-reduced-motion: reduce)'
  );

  /* =====================================
     SLIDING ANIMATION
  ===================================== */

  function animateEntry(element, direction = 1) {

    if (!element || reducedMotion.matches) return;

    if (typeof element.animate !== 'function') return;

    element.getAnimations().forEach(animation => {
      animation.cancel();
    });

    const offset = direction < 0 ? -32 : 32;

    element.animate(
      [
        {
          opacity: .35,
          transform: `translate3d(${offset}px,0,0)`
        },
        {
          opacity: 1,
          transform: 'translate3d(0,0,0)'
        }
      ],
      {
        duration: 460,
        easing: 'cubic-bezier(.22,1,.36,1)'
      }
    );

  }

  /* =====================================
     DISPLAY SELECTED PRODUCT
  ===================================== */

  function showProduct(panel, index, direction = 1) {

    const visuals = Array.from(
      panel.querySelectorAll('[data-abconc-visual]')
    );

    const details = Array.from(
      panel.querySelectorAll('[data-abconc-detail]')
    );

    const previews = Array.from(
      panel.querySelectorAll('[data-abconc-preview]')
    );

    if (!visuals.length || !details.length) return;

    const total = Math.min(
      visuals.length,
      details.length
    );

    const activeIndex = (
      index % total + total
    ) % total;

    panel._abconcIndex = activeIndex;

    /* FEATURED PRODUCT IMAGE */

    visuals.forEach((visual, i) => {

      const active = i === activeIndex;

      visual.hidden = !active;

      if (active) {
        animateEntry(visual, direction);
      }

    });

    /* PRODUCT NAME, DESCRIPTION, PRICE */

    details.forEach((detail, i) => {

      const active = i === activeIndex;

      detail.hidden = !active;

      if (active) {
        animateEntry(detail, direction);
      }

    });

    /* =====================================
       NEXT THREE PRODUCT PREVIEWS
    ===================================== */

    const nextIndexes = [];

    for (
      let i = 1;
      i <= Math.min(3, total - 1);
      i++
    ) {

      nextIndexes.push(
        (activeIndex + i) % total
      );

    }

    /* HIDE PREVIEWS BEFORE REORDERING */

    previews.forEach(preview => {

      preview.hidden = true;
      preview.style.order = '0';

    });

    /* DISPLAY THE NEXT AVAILABLE PRODUCTS */

    nextIndexes.forEach((nextIndex, order) => {

      const preview = previews[nextIndex];

      if (!preview) return;

      preview.hidden = false;
      preview.style.order = String(order);

    });

    const previewContainer = panel.querySelector(
      '[data-abconc-previews]'
    );

    if (previewContainer) {

      previewContainer.hidden =
        nextIndexes.length === 0;

      /*
        IMPORTANT FIX:

        Do not dynamically update the number
        of grid columns here.

        CSS always reserves three columns.

        When there are only two products,
        one thumbnail is displayed at 1/3
        of the right panel width.
      */

      if (nextIndexes.length) {
        animateEntry(previewContainer, direction);
      }

    }

    /* CURRENT PRODUCT POSITION */

    const position = panel.querySelector(
      '[data-abconc-position]'
    );

    if (position) {

      const current = String(
        activeIndex + 1
      ).padStart(2, '0');

      const count = String(
        total
      ).padStart(2, '0');

      position.textContent =
        `${current} / ${count}`;

    }

    /* NAVIGATION STATES */

    const prev = panel.querySelector(
      '[data-abconc-prev]'
    );

    const next = panel.querySelector(
      '[data-abconc-next]'
    );

    if (prev) {
      prev.disabled = total <= 1;
    }

    if (next) {
      next.disabled = total <= 1;
    }

  }

  /* =====================================
     CAROUSEL NAVIGATION
  ===================================== */

  function moveProduct(panel, direction) {

    const visuals = panel.querySelectorAll(
      '[data-abconc-visual]'
    );

    const count = visuals.length;

    if (count <= 1) return;

    const current = panel._abconcIndex || 0;

    const nextIndex = (
      current + direction + count
    ) % count;

    showProduct(
      panel,
      nextIndex,
      direction
    );

  }

  /* =====================================
     COLLECTION TAB SWITCHING
  ===================================== */

  function selectConcern(section, blockId) {

    const tabs = Array.from(
      section.querySelectorAll('[data-abconc-tab]')
    );

    const panels = Array.from(
      section.querySelectorAll('[data-abconc-panel]')
    );

    tabs.forEach(tab => {

      const active =
        tab.dataset.abconcTab === blockId;

      tab.classList.toggle(
        'is-active',
        active
      );

      tab.setAttribute(
        'aria-selected',
        String(active)
      );

      tab.tabIndex = active ? 0 : -1;

    });

    panels.forEach(panel => {

      const active =
        panel.dataset.abconcPanel === blockId;

      panel.hidden = !active;

      if (active) {

        showProduct(
          panel,
          0,
          1
        );

      }

    });

  }

  /* =====================================
     AJAX ADD TO CART
  ===================================== */

  async function addToCart(form, section) {

    const button = form.querySelector(
      'button[type="submit"]'
    );

    const label = button?.querySelector(
      '[data-abconc-button-text]'
    );

    const status = section.querySelector(
      '[data-abconc-cart-status]'
    );

    if (!button || button.disabled) return;

    const originalLabel =
      label?.textContent?.trim() || 'Add to cart';

    const root =
      window.Shopify?.routes?.root || '/';

    button.disabled = true;

    if (label) {
      label.textContent = 'Adding...';
    }

    if (status) {
      status.textContent = '';
    }

    try {

      const response = await fetch(
        `${root}cart/add.js`,
        {
          method: 'POST',
          body: new FormData(form),
          headers: {
            Accept: 'application/json'
          },
          credentials: 'same-origin'
        }
      );

      const data = await response.json();

      if (!response.ok) {

        throw new Error(
          data.description ||
          data.message ||
          'Unable to add this product.'
        );

      }

      if (label) {
        label.textContent = 'Added!';
      }

      if (status) {
        status.textContent =
          'Product added to your cart.';
      }

      /* REFRESH CART INFORMATION */

      try {

        const cartResponse = await fetch(
          `${root}cart.js`,
          {
            credentials: 'same-origin',
            cache: 'no-store'
          }
        );

        if (!cartResponse.ok) {
          throw new Error('Cart refresh failed');
        }

        const cart = await cartResponse.json();

        const cartIcon = document.querySelector(
          'cart-icon'
        );

        if (
          cartIcon &&
          typeof cartIcon.renderCartBubble === 'function'
        ) {

          cartIcon.renderCartBubble(
            cart.item_count
          );

        }

        /* REFRESH HORIZON CART DRAWER */

        const drawer = document.querySelector(
          'theme-drawer#cart-drawer'
        );

        if (drawer) {

          const drawerResponse = await fetch(
            `${root}cart?section_id=cart-drawer-section`,
            {
              credentials: 'same-origin',
              cache: 'no-store'
            }
          );

          if (drawerResponse.ok) {

            const html = await drawerResponse.text();

            const documentFragment =
              new DOMParser().parseFromString(
                html,
                'text/html'
              );

            const newInner = documentFragment.querySelector(
              '#cart-drawer .cart-drawer__inner'
            );

            const oldInner = drawer.querySelector(
              '.cart-drawer__inner'
            );

            if (newInner && oldInner) {
              oldInner.replaceWith(newInner);
            }

          }

          if (typeof drawer.open === 'function') {
            drawer.open();
          }

        }

      } catch (refreshError) {

        console.warn(
          'Product added but cart UI refresh failed:',
          refreshError
        );

        if (status) {
          status.textContent =
            'Product added. Open your cart to review it.';
        }

      }

    } catch (error) {

      console.error('Cart error:', error);

      if (status) {

        status.textContent =
          error.message || 'Please try again.';

      }

      if (label) {
        label.textContent = 'Try again';
      }

    } finally {

      button.disabled = false;

      window.setTimeout(() => {

        if (label && !button.disabled) {
          label.textContent = originalLabel;
        }

      }, 1800);

    }

  }

  /* =====================================
     INITIALIZE SECTION
  ===================================== */

  function initialize(section) {

    if (!section) return;

    if (section.dataset.abconcReady === 'true') {
      return;
    }

    section.dataset.abconcReady = 'true';

    const firstTab = section.querySelector(
      '[data-abconc-tab]'
    );

    if (firstTab) {

      selectConcern(
        section,
        firstTab.dataset.abconcTab
      );

    }

    /* CLICK EVENTS */

    section.addEventListener(
      'click',
      event => {

        const tab = event.target.closest(
          '[data-abconc-tab]'
        );

        if (tab && section.contains(tab)) {

          selectConcern(
            section,
            tab.dataset.abconcTab
          );

          return;

        }

        const panel = event.target.closest(
          '[data-abconc-panel]'
        );

        if (!panel || !section.contains(panel)) {
          return;
        }

        /* PREVIOUS */

        if (event.target.closest('[data-abconc-prev]')) {

          moveProduct(panel, -1);
          return;

        }

        /* NEXT */

        if (event.target.closest('[data-abconc-next]')) {

          moveProduct(panel, 1);
          return;

        }

        /* PREVIEW CLICK */

        const preview = event.target.closest(
          '[data-abconc-preview]'
        );

        if (preview) {

          const nextIndex = Number(
            preview.dataset.abconcPreview
          );

          const previousIndex =
            panel._abconcIndex || 0;

          showProduct(
            panel,
            nextIndex,
            nextIndex >= previousIndex ? 1 : -1
          );

        }

      }
    );

    /* KEYBOARD TAB NAVIGATION */

    section.addEventListener(
      'keydown',
      event => {

        const tab = event.target.closest(
          '[data-abconc-tab]'
        );

        if (!tab) return;

        if (
          event.key !== 'ArrowRight' &&
          event.key !== 'ArrowLeft'
        ) {
          return;
        }

        event.preventDefault();

        const tabs = Array.from(
          section.querySelectorAll('[data-abconc-tab]')
        );

        const index = tabs.indexOf(tab);

        const direction =
          event.key === 'ArrowRight' ? 1 : -1;

        const nextIndex = (
          index + direction + tabs.length
        ) % tabs.length;

        const nextTab = tabs[nextIndex];

        if (!nextTab) return;

        selectConcern(
          section,
          nextTab.dataset.abconcTab
        );

        nextTab.focus();

      }
    );

    /* ADD TO CART FORM */

    section.addEventListener(
      'submit',
      event => {

        const form = event.target.closest(
          '[data-abconc-form]'
        );

        if (!form) return;

        event.preventDefault();

        addToCart(
          form,
          section
        );

      }
    );

  }

  /* =====================================
     INITIALIZE ALL SECTIONS
  ===================================== */

  function initializeAll(root = document) {

    if (
      root.matches &&
      root.matches(SELECTOR)
    ) {
      initialize(root);
    }

    root.querySelectorAll(SELECTOR)
      .forEach(initialize);

  }

  if (document.readyState === 'loading') {

    document.addEventListener(
      'DOMContentLoaded',
      () => initializeAll(document),
      { once: true }
    );

  } else {

    initializeAll(document);

  }

  /* =====================================
     SHOPIFY THEME EDITOR
  ===================================== */

  document.addEventListener(
    'shopify:section:load',
    event => {

      initializeAll(event.target);

    }
  );

  document.addEventListener(
    'shopify:block:select',
    event => {

      const section = event.target.closest(SELECTOR)
        || event.target.querySelector(SELECTOR);

      if (!section) return;

      const tab = event.target.matches?.(
        '[data-abconc-tab]'
      )
        ? event.target
        : event.target.querySelector(
            '[data-abconc-tab]'
          );

      if (tab) {

        selectConcern(
          section,
          tab.dataset.abconcTab
        );

      }

    }
  );

})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ayurveda-new-arrivals"] && !Shopify.designMode) return;
  try {
    

/*
  AYURVEDA BHARAT — NEW ARRIVALS CAROUSEL

  - Smooth product-by-product movement
  - Previous / Next buttons
  - Disabled states at carousel boundaries
  - Native touch/swipe support
  - Resize handling
  - Shopify theme editor initialization
*/

(() => {

  function initialize(section) {

    if (!section) return;

    if (section.dataset.abArrivalsReady === 'true') {
      return;
    }

    const track = section.querySelector(
      '[data-ab-arrivals-track]'
    );

    const prev = section.querySelector(
      '[data-ab-arrivals-prev]'
    );

    const next = section.querySelector(
      '[data-ab-arrivals-next]'
    );

    if (!track) return;

    section.dataset.abArrivalsReady = 'true';

    const cards = Array.from(track.children);

    /* UPDATE ARROW STATES */

    function updateArrows() {

      if (!prev || !next) return;

      const maxScroll = Math.max(
        0,
        track.scrollWidth - track.clientWidth
      );

      prev.disabled = track.scrollLeft <= 2;

      next.disabled =
        track.scrollLeft >= maxScroll - 2;

    }

    /* MOVE ONE PRODUCT CARD */

    function move(direction) {

      if (!cards.length) return;

      const firstCard = cards[0];

      const cardWidth =
        firstCard.getBoundingClientRect().width;

      const styles = getComputedStyle(track);

      const gap =
        parseFloat(styles.columnGap) || 0;

      const step = cardWidth + gap;

      if (step <= 0) return;

      const currentIndex = Math.round(
        track.scrollLeft / step
      );

      const targetIndex = Math.min(
        cards.length - 1,
        Math.max(0, currentIndex + direction)
      );

      const targetLeft = targetIndex * step;

      const reducedMotion = window.matchMedia(
        '(prefers-reduced-motion: reduce)'
      ).matches;

      track.scrollTo({
        left: targetLeft,
        behavior: reducedMotion ? 'auto' : 'smooth'
      });

    }

    if (prev) {
      prev.addEventListener('click', () => {
        move(-1);
      });
    }

    if (next) {
      next.addEventListener('click', () => {
        move(1);
      });
    }

    /* UPDATE WHILE SWIPING OR SCROLLING */

    let ticking = false;

    track.addEventListener(
      'scroll',
      () => {

        if (ticking) return;

        ticking = true;

        requestAnimationFrame(() => {
          updateArrows();
          ticking = false;
        });

      },
      { passive: true }
    );

    /* HANDLE RESPONSIVE SIZE CHANGES */

    if ('ResizeObserver' in window) {

      const observer = new ResizeObserver(() => {
        updateArrows();
      });

      observer.observe(track);

      section.abArrivalsObserver = observer;

    } else {

      window.addEventListener(
        'resize',
        updateArrows,
        { passive: true }
      );

    }

    updateArrows();

  }

  /* INITIALIZE MULTIPLE INSTANCES */

  function initializeAll(scope) {

    if (!scope) return;

    if (
      scope.matches &&
      scope.matches('[data-ab-arrivals]')
    ) {
      initialize(scope);
    }

    scope.querySelectorAll(
      '[data-ab-arrivals]'
    ).forEach(initialize);

  }

  /* INITIAL PAGE LOAD */

  if (document.readyState === 'loading') {

    document.addEventListener(
      'DOMContentLoaded',
      () => initializeAll(document)
    );

  } else {

    initializeAll(document);

  }

  /* SHOPIFY THEME EDITOR */

  document.addEventListener(
    'shopify:section:load',
    event => {

      initializeAll(event.target);

    }
  );

  document.addEventListener(
    'shopify:section:unload',
    event => {

      const section = event.target.querySelector(
        '[data-ab-arrivals]'
      );

      if (section && section.abArrivalsObserver) {
        section.abArrivalsObserver.disconnect();
      }

    }
  );

})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ayurveda-philosophy-scroll"] && !Shopify.designMode) return;
  try {
    

(() => {

  /*
    AYURVEDA BHARAT — SCROLL CONTROLLER

    Changes:
    - Correct progress calculation
    - Reliable scroll events
    - No persistent editor story lock
    - Supports reverse scrolling
    - Multiple instances supported
  */

  const SELECTOR = '[data-ab-story]';

  const instances = new Set();

  let scheduled = false;

  /* =====================================
     HELPERS
  ===================================== */

  function clamp(value, min = 0, max = 1) {
    return Math.min(
      max,
      Math.max(min, value)
    );
  }

  function getSlides(section) {
    return Array.from(
      section.querySelectorAll(
        '[data-ab-story-slide]'
      )
    );
  }

  /* =====================================
     ACTIVATE STORY
  ===================================== */

  function activate(section, requestedIndex) {

    const slides = getSlides(section);

    if (!slides.length) return;

    const index = Math.max(
      0,
      Math.min(
        slides.length - 1,
        requestedIndex
      )
    );

    if (section._abStoryActive === index) {
      return;
    }

    section._abStoryActive = index;

    slides.forEach((slide, position) => {

      const visible = position === index;

      slide.classList.toggle(
        'is-active',
        visible
      );

      slide.setAttribute(
        'aria-hidden',
        String(!visible)
      );

      slide.inert = !visible;

    });

  }

  /* =====================================
     CALCULATE SCROLL PROGRESS
  ===================================== */

  function update(section) {

    if (!section.isConnected) {

      instances.delete(section);
      return;

    }

    const slides = getSlides(section);

    if (!slides.length) return;

    if (slides.length === 1) {

      activate(section, 0);
      return;

    }

    const stickyViewport = section.querySelector(
      '[data-ab-story-viewport]'
    );

    if (!stickyViewport) return;

    const rect = section.getBoundingClientRect();

    const viewportRect =
      stickyViewport.getBoundingClientRect();

    const stickyTop = parseFloat(
      getComputedStyle(stickyViewport).top
    ) || 0;

    /*
      Calculate the actual scrollable distance
      of the story section, excluding the
      sticky viewport height.
    */

    const totalTravel = Math.max(
      1,
      rect.height - viewportRect.height
    );

    /*
      How far the user has scrolled through
      the sticky section.
    */

    const moved = clamp(
      stickyTop - rect.top,
      0,
      totalTravel
    );

    const progress = moved / totalTravel;

    /*
      Divide available scroll distance
      evenly across all stories.
    */

    const index = Math.min(
      slides.length - 1,
      Math.floor(progress * slides.length)
    );

    activate(section, index);

  }

  /* =====================================
     REQUEST ANIMATION FRAME
  ===================================== */

  function render() {

    scheduled = false;

    instances.forEach(update);

  }

  function requestRender() {

    if (scheduled) return;

    scheduled = true;

    requestAnimationFrame(render);

  }

  /* =====================================
     REGISTER SECTION INSTANCES
  ===================================== */

  function register(root = document) {

    if (root.matches?.(SELECTOR)) {

      instances.add(root);
      root._abStoryActive = -1;

    }

    root.querySelectorAll?.(SELECTOR)
      .forEach(section => {

        instances.add(section);

        section._abStoryActive = -1;

      });

    requestRender();

  }

  /* =====================================
     UNREGISTER REMOVED SECTIONS
  ===================================== */

  function unregister(root) {

    if (root.matches?.(SELECTOR)) {
      instances.delete(root);
    }

    root.querySelectorAll?.(SELECTOR)
      .forEach(section => {
        instances.delete(section);
      });

  }

  /* =====================================
     INITIALIZE
  ===================================== */

  if (document.readyState === 'loading') {

    document.addEventListener(
      'DOMContentLoaded',
      () => register(),
      { once: true }
    );

  } else {

    register();

  }

  /* =====================================
     SCROLL LISTENERS
  ===================================== */

  window.addEventListener(
    'scroll',
    requestRender,
    { passive: true }
  );

  /*
    Capture scroll events as well.
    This helps when the theme editor
    uses a nested scrolling container.
  */

  document.addEventListener(
    'scroll',
    requestRender,
    {
      capture: true,
      passive: true
    }
  );

  window.addEventListener(
    'resize',
    requestRender,
    { passive: true }
  );

  window.addEventListener(
    'pageshow',
    requestRender
  );

  /* =====================================
     SHOPIFY THEME EDITOR
  ===================================== */

  document.addEventListener(
    'shopify:section:load',
    event => {

      register(event.target);

    }
  );

  document.addEventListener(
    'shopify:section:unload',
    event => {

      unregister(event.target);

    }
  );

  document.addEventListener(
    'shopify:section:reorder',
    requestRender
  );

  /* =====================================
     BLOCK SELECTION
  ===================================== */

  document.addEventListener(
    'shopify:block:select',
    event => {

      const block =
        event.target.closest?.(
          '[data-ab-story-slide]'
        ) ||
        event.target.querySelector?.(
          '[data-ab-story-slide]'
        );

      const section = block?.closest(SELECTOR);

      if (!section) return;

      const index = getSlides(section).indexOf(
        block
      );

      if (index < 0) return;

      /*
        Display the selected story in the
        theme editor.

        IMPORTANT:
        Do not lock this index permanently.
        Subsequent scrolling must continue
        controlling the active story.
      */

      activate(section, index);

    }
  );

  document.addEventListener(
    'shopify:block:deselect',
    requestRender
  );

})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ayurveda-product-accordions"] && !Shopify.designMode) return;
  try {
    
(() => {
  function activateTab(tab, focusTab = false) {
    if (!tab) return;

    const section = tab.closest('[data-abpt]');
    if (!section) return;

    const selectedKey = tab.dataset.abptTab;

    const tabs = Array.from(section.querySelectorAll('[data-abpt-tab]'));
    const panels = Array.from(section.querySelectorAll('[data-abpt-panel]'));

    tabs.forEach(item => {
      const isActive = item.dataset.abptTab === selectedKey;

      item.classList.toggle('is-active', isActive);
      item.setAttribute('aria-selected', String(isActive));
      item.tabIndex = isActive ? 0 : -1;
    });

    panels.forEach(panel => {
      const isActive = panel.dataset.abptPanel === selectedKey;
      panel.hidden = !isActive;
    });

    const list = tab.closest('[role="tablist"]');

    if (list) {
      const tabLeft = tab.offsetLeft - list.offsetLeft;
      const tabRight = tabLeft + tab.offsetWidth;
      const visibleLeft = list.scrollLeft;
      const visibleRight = visibleLeft + list.clientWidth;

      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      if (tabLeft < visibleLeft || tabRight > visibleRight) {
        list.scrollTo({
          left: Math.max(0, tabLeft - 12),
          behavior: reduceMotion ? 'instant' : 'smooth'
        });
      }
    }

    if (focusTab) {
      tab.focus({ preventScroll: true });
    }
  }

  document.addEventListener('click', event => {
    const tab = event.target.closest?.('[data-abpt-tab]');
    if (!tab) return;
    activateTab(tab);
  });

  document.addEventListener('keydown', event => {
    const tab = event.target.closest?.('[data-abpt-tab]');
    if (!tab) return;

    const section = tab.closest('[data-abpt]');
    if (!section) return;

    const tabs = Array.from(section.querySelectorAll('[data-abpt-tab]'));
    const index = tabs.indexOf(tab);

    if (index === -1) return;

    let nextIndex = index;

    switch (event.key) {
      case 'ArrowRight':
        nextIndex = (index + 1) % tabs.length;
        break;
      case 'ArrowLeft':
        nextIndex = (index - 1 + tabs.length) % tabs.length;
        break;
      case 'Home':
        nextIndex = 0;
        break;
      case 'End':
        nextIndex = tabs.length - 1;
        break;
      default:
        return;
    }

    event.preventDefault();
    activateTab(tabs[nextIndex], true);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ayurveda-product-page"] && !Shopify.designMode) return;
  try {
    

/* AYURVEDA BHARAT — PRODUCT PAGE CONTROLLER */

(() => {

  const SELECTOR = '[data-abp-product]';

  function initialize(section) {

    if (!section || section.dataset.abpReady === 'true') {
      return;
    }

    const dataElement = section.querySelector(
      '[data-abp-variants]'
    );

    if (!dataElement) return;

    let variants = [];

    try {
      variants = JSON.parse(dataElement.textContent);
    } catch (error) {
      console.error('AB product variants:', error);
      return;
    }

    section.dataset.abpReady = 'true';

    const thumbnails = Array.from(
      section.querySelectorAll('[data-abp-thumbnail]')
    );

    const mediaItems = Array.from(
      section.querySelectorAll('[data-abp-media]')
    );

    const groups = Array.from(
      section.querySelectorAll('[data-abp-option-group]')
    );

    const variantInput = section.querySelector(
      '[data-abp-variant-id]'
    );

    const price = section.querySelector('[data-abp-price]');
    const compare = section.querySelector('[data-abp-compare]');
    const sku = section.querySelector('[data-abp-sku]');
    const skuWrap = section.querySelector('[data-abp-sku-wrap]');
    const addButton = section.querySelector('[data-abp-add]');
    const addLabel = section.querySelector('[data-abp-add-label]');
    const availability = section.querySelector('[data-abp-availability]');
    const quantity = section.querySelector('[data-abp-quantity]');
    const minus = section.querySelector('[data-abp-minus]');
    const plus = section.querySelector('[data-abp-plus]');

    /* PRODUCT IMAGE SWITCHING */

    function showMedia(id) {

      const mediaId = String(id);

      if (!mediaItems.some(
        item => item.dataset.mediaId === mediaId
      )) {
        return;
      }

      mediaItems.forEach(item => {

        const active = item.dataset.mediaId === mediaId;

        if (!active) {
          item.querySelectorAll('video').forEach(video => {
            video.pause();
          });
        }

        item.hidden = !active;

      });

      thumbnails.forEach(thumb => {

        const active = thumb.dataset.mediaId === mediaId;

        thumb.classList.toggle('is-active', active);

        thumb.setAttribute(
          'aria-pressed',
          String(active)
        );

      });

    }

    thumbnails.forEach(thumb => {

      thumb.addEventListener('click', () => {
        showMedia(thumb.dataset.mediaId);
      });

    });

    /* QUANTITY HELPERS */

    function rules() {

      return {
        min: Math.max(1, Number(quantity?.min) || 1),
        step: Math.max(1, Number(quantity?.step) || 1),
        max: Number(quantity?.max) || 0
      };

    }

    function setQuantity(raw) {

      if (!quantity) return;

      const { min, step, max } = rules();

      let value = Number(raw);

      if (!Number.isFinite(value)) {
        value = min;
      }

      value = Math.max(min, value);

      value = min + Math.max(
        0,
        Math.round((value - min) / step)
      ) * step;

      if (max > 0 && value > max) {

        const steps = Math.max(
          0,
          Math.floor((max - min) / step)
        );

        value = min + steps * step;

      }

      quantity.value = String(value);

      if (minus) {
        minus.disabled = value <= min;
      }

      if (plus) {
        plus.disabled = max > 0 && value + step > max;
      }

    }

    minus?.addEventListener('click', () => {

      setQuantity(
        Number(quantity.value) - rules().step
      );

    });

    plus?.addEventListener('click', () => {

      setQuantity(
        Number(quantity.value) + rules().step
      );

    });

    quantity?.addEventListener('change', () => {
      setQuantity(quantity.value);
    });

    /* VARIANT SELECTION */

    function getSelectedOptions() {

      return groups.map(group => {

        const selected = group.querySelector(
          '[data-abp-option]:checked'
        );

        return selected ? selected.value : '';

      });

    }

    function updateVariant(variant, initial = false) {

      const available = Boolean(
        variant && variant.available
      );

      if (variantInput) {

        variantInput.value = variant
          ? String(variant.id)
          : '';

        variantInput.disabled = !available;

      }

      if (price) {
        price.textContent = variant
          ? variant.price_html
          : 'Unavailable';
      }

      if (compare) {

        const hasCompare = Boolean(
          variant &&
          Number(variant.compare_at_price) >
          Number(variant.price)
        );

        compare.hidden = !hasCompare;

        if (hasCompare) {
          compare.textContent = variant.compare_at_html;
        }

      }

      if (skuWrap && sku) {

        skuWrap.hidden = !variant?.sku;
        sku.textContent = variant?.sku || '';

      }

      if (addButton) {
        addButton.disabled = !available;
      }

      if (addLabel) {

        addLabel.textContent = !variant
          ? 'Unavailable'
          : available
            ? 'Add to cart'
            : 'Sold out';

      }

      if (availability) {

        availability.textContent = !variant
          ? 'This combination is unavailable.'
          : !available
            ? 'Currently sold out.'
            : '';

      }

      if (quantity && variant) {

        quantity.min = String(
          Math.max(1, Number(variant.quantity_min) || 1)
        );

        quantity.step = String(
          Math.max(1, Number(variant.quantity_step) || 1)
        );

        if (Number(variant.quantity_max) > 0) {

          quantity.max = String(variant.quantity_max);

        } else {

          quantity.removeAttribute('max');

        }

        setQuantity(quantity.value);

      }

      if (variant?.media_id) {
        showMedia(variant.media_id);
      }

      if (
        variant &&
        !initial &&
        !window.Shopify?.designMode
      ) {

        const url = new URL(window.location.href);

        url.searchParams.set(
          'variant',
          String(variant.id)
        );

        window.history.replaceState(
          window.history.state,
          '',
          url.toString()
        );

      }

    }

    function changeVariant() {

      const values = getSelectedOptions();

      const match = variants.find(variant => {

        return variant.options.every(
          (option, index) => option === values[index]
        );

      });

      updateVariant(match || null);

    }

    groups.forEach(group => {

      group.addEventListener('change', changeVariant);

    });

    /* INITIAL STATE */

    const initialVariant = variants.find(variant => {

      return String(variant.id) ===
        String(variantInput?.value);

    });

    if (initialVariant) {
      updateVariant(initialVariant, true);
    }

    setQuantity(quantity?.value);

  }

  function initializeAll(root = document) {

    if (root.matches?.(SELECTOR)) {
      initialize(root);
    }

    root.querySelectorAll?.(SELECTOR)
      .forEach(initialize);

  }

  if (document.readyState === 'loading') {

    document.addEventListener(
      'DOMContentLoaded',
      () => initializeAll(),
      { once: true }
    );

  } else {

    initializeAll();

  }

  document.addEventListener(
    'shopify:section:load',
    event => initializeAll(event.target)
  );

})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ayurveda-testimonials"] && !Shopify.designMode) return;
  try {
    

/*
  AYURVEDA BHARAT — TESTIMONIAL CAROUSEL

  - Continuous requestAnimationFrame scrolling
  - Triple-copy seamless loop
  - Left or right autoplay
  - Smooth one-card arrow navigation
  - Pauses for hover, focus and touch
  - Pauses while out of viewport
  - Pauses when browser tab is hidden
  - Respects reduced-motion preferences
  - Supports Shopify theme editor
*/

(() => {

  const SELECTOR = '[data-ab-testimonials]';

  const reducedMotion = window.matchMedia(
    '(prefers-reduced-motion: reduce)'
  );

  function initialize(section) {

    if (!section) return;

    if (section.dataset.abrevReady === 'true') {
      return;
    }

    const viewport = section.querySelector(
      '[data-abrev-carousel]'
    );

    if (!viewport) return;

    section.dataset.abrevReady = 'true';

    const reviewCount = Number(
      viewport.dataset.reviewCount || 0
    );

    const autoplayEnabled =
      viewport.dataset.autoplay === 'true' &&
      reviewCount > 1;

    const direction =
      viewport.dataset.direction === 'right'
        ? -1
        : 1;

    const speed = Math.max(
      1,
      Number(viewport.dataset.speed) || 18
    );

    const pauseOnHover =
      viewport.dataset.pauseHover === 'true';

    const previousButton = section.querySelector(
      '[data-abrev-prev]'
    );

    const nextButton = section.querySelector(
      '[data-abrev-next]'
    );

    const status = section.querySelector(
      '[data-abrev-status]'
    );

    const firstCopy = viewport.querySelector(
      '[data-abrev-copy="1"]'
    );

    const middleCopy = viewport.querySelector(
      '[data-abrev-copy="2"]'
    );

    const lastCopy = viewport.querySelector(
      '[data-abrev-copy="3"]'
    );

    const allCards = Array.from(
      viewport.querySelectorAll('[data-abrev-card]')
    );

    let frameId = null;
    let lastFrameTime = 0;

    let isVisible = true;
    let isHovered = false;
    let isFocused = false;
    let isTouching = false;
    let isDragging = false;

    let manualPauseUntil = 0;
    let destroyed = false;

    let cycleWidth = 0;
    let centerStart = 0;

    /* ==================================
       CALCULATE ONE COMPLETE REVIEW SET
    ================================== */

    function measure(reset = false) {

      if (!middleCopy) return;

      centerStart = middleCopy.offsetLeft;

      if (firstCopy && lastCopy) {

        cycleWidth =
          middleCopy.offsetLeft -
          firstCopy.offsetLeft;

      } else {

        cycleWidth = 0;

      }

      if (reset && reviewCount > 1) {

        viewport.scrollLeft = centerStart;

      }

    }

    /* ==================================
       SEAMLESS INFINITE LOOP
    ================================== */

    function normalizePosition() {

      if (!cycleWidth || !middleCopy) return;

      const current = viewport.scrollLeft;

      /*
        The three copies are identical.

        When the scroll reaches the adjacent
        copy, reposition it by exactly one
        copy width.

        This produces the same visual cards
        without a visible jump.
      */

      if (current >= centerStart + cycleWidth) {

        viewport.scrollLeft =
          current - cycleWidth;

      } else if (current < centerStart) {

        viewport.scrollLeft =
          current + cycleWidth;

      }

    }

    /* ==================================
       AUTOPLAY CONDITIONS
    ================================== */

    function canAutoScroll(now) {

      if (destroyed) return false;

      if (!autoplayEnabled) return false;

      if (reducedMotion.matches) return false;

      if (document.hidden) return false;

      if (!isVisible) return false;

      if (isHovered && pauseOnHover) return false;

      if (isFocused) return false;

      if (isTouching || isDragging) return false;

      if (now < manualPauseUntil) return false;

      return cycleWidth > 0;

    }

    /* ==================================
       CONTINUOUS FRAME UPDATE
    ================================== */

    function frame(now) {

      frameId = null;

      if (destroyed) return;

      if (!section.isConnected) {
        destroy();
        return;
      }

      const elapsed = lastFrameTime
        ? Math.min(now - lastFrameTime, 50)
        : 0;

      lastFrameTime = now;

      if (canAutoScroll(now)) {

        const distance =
          direction * speed * (elapsed / 1000);

        viewport.scrollLeft += distance;

        normalizePosition();

      } else if (
        now >= manualPauseUntil &&
        !isTouching &&
        !isDragging
      ) {

        /*
          Recenter after the manual movement
          finishes. The repeated cards remain
          visually identical.
        */

        normalizePosition();

      }

      if (isVisible && autoplayEnabled) {

        frameId = requestAnimationFrame(frame);

      }

    }

    function startAnimation() {

      if (destroyed) return;

      if (!autoplayEnabled) return;

      if (!isVisible) return;

      if (frameId !== null) return;

      lastFrameTime = 0;

      frameId = requestAnimationFrame(frame);

    }

    function stopAnimation() {

      if (frameId !== null) {

        cancelAnimationFrame(frameId);

        frameId = null;

      }

      lastFrameTime = 0;

    }

    /* ==================================
       PAUSE AFTER MANUAL MOVEMENT
    ================================== */

    function pauseForInteraction(duration = 3200) {

      manualPauseUntil = Math.max(
        manualPauseUntil,
        performance.now() + duration
      );

    }

    /* ==================================
       ARROW NAVIGATION
    ================================== */

    function moveOneCard(moveDirection) {

      if (reviewCount <= 1) return;

      pauseForInteraction();

      const current = viewport.scrollLeft;

      const tolerance = 5;

      let target = null;

      if (moveDirection > 0) {

        target = allCards.find(card => {
          return card.offsetLeft > current + tolerance;
        });

      } else {

        for (let i = allCards.length - 1; i >= 0; i--) {

          if (allCards[i].offsetLeft < current - tolerance) {

            target = allCards[i];
            break;

          }

        }

      }

      if (!target) {

        normalizePosition();

        const updated = viewport.scrollLeft;

        if (moveDirection > 0) {

          target = allCards.find(card => {
            return card.offsetLeft > updated + tolerance;
          });

        } else {

          for (let i = allCards.length - 1; i >= 0; i--) {

            if (
              allCards[i].offsetLeft <
              updated - tolerance
            ) {

              target = allCards[i];
              break;

            }

          }

        }

      }

      if (!target) return;

      viewport.scrollTo({
        left: target.offsetLeft,
        behavior: reducedMotion.matches
          ? 'instant'
          : 'smooth'
      });

      if (status) {

        status.textContent = moveDirection > 0
          ? 'Showing next customer review'
          : 'Showing previous customer review';

      }

    }

    /* ==================================
       NAVIGATION BUTTONS
    ================================== */

    if (previousButton) {

      previousButton.addEventListener(
        'click',
        () => moveOneCard(-1)
      );

    }

    if (nextButton) {

      nextButton.addEventListener(
        'click',
        () => moveOneCard(1)
      );

    }

    /* ==================================
       MOUSE HOVER
    ================================== */

    section.addEventListener('mouseenter', () => {

      isHovered = true;

    });

    section.addEventListener('mouseleave', () => {

      isHovered = false;

      lastFrameTime = 0;

    });

    /* ==================================
       KEYBOARD FOCUS
    ================================== */

    section.addEventListener('focusin', () => {

      isFocused = true;

    });

    section.addEventListener('focusout', () => {

      queueMicrotask(() => {

        isFocused = section.contains(
          document.activeElement
        );

      });

    });

    /* ==================================
       TOUCH INTERACTION
    ================================== */

    viewport.addEventListener(
      'touchstart',
      () => {

        isTouching = true;

      },
      { passive: true }
    );

    viewport.addEventListener(
      'touchend',
      () => {

        isTouching = false;
        pauseForInteraction();

      },
      { passive: true }
    );

    viewport.addEventListener(
      'touchcancel',
      () => {

        isTouching = false;
        pauseForInteraction();

      },
      { passive: true }
    );

    /* ==================================
       POINTER DRAGGING
    ================================== */

    viewport.addEventListener(
      'pointerdown',
      event => {

        if (event.pointerType === 'mouse') {

          isDragging = true;

        }

      }
    );

    window.addEventListener(
      'pointerup',
      () => {

        if (isDragging) {

          isDragging = false;
          pauseForInteraction();

        }

      }
    );

    /* ==================================
       WHEEL / TRACKPAD INTERACTION
    ================================== */

    viewport.addEventListener(
      'wheel',
      () => {

        pauseForInteraction();

      },
      { passive: true }
    );

    /* ==================================
       KEYBOARD NAVIGATION
    ================================== */

    viewport.addEventListener(
      'keydown',
      event => {

        if (event.key === 'ArrowLeft') {

          event.preventDefault();

          moveOneCard(-1);

        } else if (event.key === 'ArrowRight') {

          event.preventDefault();

          moveOneCard(1);

        }

      }
    );

    /* ==================================
       SECTION VISIBILITY
    ================================== */

    let intersectionObserver = null;

    if ('IntersectionObserver' in window) {

      intersectionObserver = new IntersectionObserver(
        entries => {

          for (const entry of entries) {

            isVisible = entry.isIntersecting;

            if (isVisible) {

              startAnimation();

            } else {

              stopAnimation();

            }

          }

        },
        {
          threshold: 0.05
        }
      );

      intersectionObserver.observe(section);

    }

    /* ==================================
       RESPONSIVE RECALCULATION
    ================================== */

    let resizeObserver = null;
    let resizeFrame = null;

    function recalculate() {

      if (destroyed) return;

      if (resizeFrame !== null) {

        cancelAnimationFrame(resizeFrame);

      }

      resizeFrame = requestAnimationFrame(() => {

        resizeFrame = null;

        measure(true);
        lastFrameTime = 0;

      });

    }

    if ('ResizeObserver' in window) {

      resizeObserver = new ResizeObserver(
        recalculate
      );

      resizeObserver.observe(viewport);

    }

    /* ==================================
       BROWSER VISIBILITY
    ================================== */

    function handleVisibilityChange() {

      lastFrameTime = 0;

      if (!document.hidden) {
        startAnimation();
      }

    }

    document.addEventListener(
      'visibilitychange',
      handleVisibilityChange
    );

    /* ==================================
       REDUCED MOTION CHANGES
    ================================== */

    function handleMotionChange() {

      lastFrameTime = 0;

    }

    if (typeof reducedMotion.addEventListener === 'function') {

      reducedMotion.addEventListener(
        'change',
        handleMotionChange
      );

    }

    /* ==================================
       CLEANUP
    ================================== */

    function destroy() {

      if (destroyed) return;

      destroyed = true;

      stopAnimation();

      if (intersectionObserver) {
        intersectionObserver.disconnect();
      }

      if (resizeObserver) {
        resizeObserver.disconnect();
      }

      if (resizeFrame !== null) {
        cancelAnimationFrame(resizeFrame);
      }

      document.removeEventListener(
        'visibilitychange',
        handleVisibilityChange
      );

      if (typeof reducedMotion.removeEventListener === 'function') {

        reducedMotion.removeEventListener(
          'change',
          handleMotionChange
        );

      }

      section.dataset.abrevReady = 'false';

    }

    section._abrevDestroy = destroy;

    /* ==================================
       INITIAL POSITION
    ================================== */

    measure(true);

    /*
      The middle copy is the starting point.
      This gives scrolling room in both
      directions and makes the loop seamless.
    */

    startAnimation();

  }

  /* =====================================
     INITIALIZE SECTIONS
  ===================================== */

  function initializeAll(root = document) {

    if (root.matches?.(SELECTOR)) {
      initialize(root);
    }

    root.querySelectorAll?.(SELECTOR)
      .forEach(initialize);

  }

  /* =====================================
     INITIAL LOAD
  ===================================== */

  if (document.readyState === 'loading') {

    document.addEventListener(
      'DOMContentLoaded',
      () => initializeAll(document),
      { once: true }
    );

  } else {

    initializeAll(document);

  }

  /* =====================================
     SHOPIFY THEME EDITOR
  ===================================== */

  document.addEventListener(
    'shopify:section:load',
    event => {

      initializeAll(event.target);

    }
  );

  document.addEventListener(
    'shopify:section:unload',
    event => {

      const sections = [];

      if (event.target.matches?.(SELECTOR)) {
        sections.push(event.target);
      }

      event.target.querySelectorAll?.(SELECTOR)
        .forEach(section => {
          sections.push(section);
        });

      sections.forEach(section => {

        if (typeof section._abrevDestroy === 'function') {
          section._abrevDestroy();
        }

      });

    }
  );

})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ayurveda-values"] && !Shopify.designMode) return;
  try {
    

/*
  AYURVEDA BHARAT — REVISED SCROLL ANIMATION

  No sticky pinning.

  Scroll down:
  - Left content progressively reveals.
  - Cards move apart from a close layout.

  Scroll up:
  - Animation reverses.

  Safety:
  - Cards never overlap.
  - Text remains accessible.
  - No extra artificial scroll height.
  - Multiple section instances supported.
  - Shopify theme editor compatible.
*/

(() => {

  const selector = '[data-ab-values]';

  const reducedMotion = window.matchMedia(
    '(prefers-reduced-motion: reduce)'
  );

  const twoColumnQuery = window.matchMedia(
    '(min-width: 600px)'
  );

  const mobileQuery = window.matchMedia(
    '(max-width: 900px)'
  );

  let animationFrame = null;

  /* ==================================
     HELPERS
  ================================== */

  function clamp(value, min = 0, max = 1) {
    return Math.min(max, Math.max(min, value));
  }

  function smoothstep(value) {
    const p = clamp(value);

    return p * p * (3 - 2 * p);
  }

  /* ==================================
     SCROLL PROGRESS
  ================================== */

  function getProgress(section) {

    const rect = section.getBoundingClientRect();

    const viewportHeight = window.innerHeight;

    /*
      Start when the section approaches
      the bottom of the viewport.

      Complete while its content is
      comfortably visible.

      This avoids the previous situation
      where the section remained invisible
      until much further down the page.
    */

    const startPoint = viewportHeight * 0.94;

    const configuredDistance =
      Number(section.dataset.scrollDistance) || 580;

    const distance = mobileQuery.matches
      ? viewportHeight * 0.52
      : configuredDistance;

    return clamp(
      (startPoint - rect.top) /
      Math.max(1, distance)
    );

  }

  /* ==================================
     LEFT TEXT REVEAL
  ================================== */

  function updateText(section, progress) {

    const items = section.querySelectorAll(
      '[data-ab-values-reveal]'
    );

    items.forEach((item, index) => {

      /*
        Each text element receives a small
        staggered scroll offset.
      */

      const delay = index * 0.09;

      const localProgress = clamp(
        (progress - delay) / 0.70
      );

      const eased = smoothstep(localProgress);

      /*
        Left-to-right reveal.

        Initial clip is partial rather than
        completely invisible, preventing
        the earlier blank-content problem.
      */

      const rightClip = (1 - eased) * 85;

      const translateX = (1 - eased) * -22;

      const opacity = 0.35 + eased * 0.65;

      item.style.clipPath =
        `inset(0 ${rightClip.toFixed(2)}% 0 0)`;

      item.style.transform =
        `translate3d(${translateX.toFixed(2)}px, 0, 0)`;

      item.style.opacity =
        opacity.toFixed(3);

    });

  }

  /* ==================================
     CARD EXPANSION
  ================================== */

  function updateCards(section, progress) {

    const grid = section.querySelector(
      '[data-ab-values-cards]'
    );

    if (!grid) return;

    const cards = Array.from(
      grid.querySelectorAll('[data-ab-values-card]')
    );

    const eased = smoothstep(progress);

    const closed = 1 - eased;

    const twoColumns = twoColumnQuery.matches;

    /*
      Never move a card beyond half the
      grid gap. The cards remain distinct
      even at the start of the animation.
    */

    const gridStyles = getComputedStyle(grid);

    const horizontalGap =
      parseFloat(gridStyles.columnGap) || 18;

    const verticalGap =
      parseFloat(gridStyles.rowGap) || 18;

    const horizontalInset = Math.max(
      0,
      Math.min(9, (horizontalGap - 4) / 2)
    );

    const verticalInset = Math.max(
      0,
      Math.min(9, (verticalGap - 4) / 2)
    );

    cards.forEach((card, index) => {

      let translateX = 0;
      let translateY = 0;

      if (twoColumns) {

        /*
          Stable 2x2 card layout:

          0 = top-left
          1 = top-right
          2 = bottom-left
          3 = bottom-right
        */

        const column = index % 2;
        const row = Math.floor(index / 2);

        const directionX = column === 0 ? 1 : -1;
        const directionY = row === 0 ? 1 : -1;

        translateX =
          directionX * horizontalInset * closed;

        translateY =
          directionY * verticalInset * closed;

      } else {

        /*
          Mobile uses one column.

          Cards move only vertically,
          never sideways.
        */

        const directionY =
          index % 2 === 0 ? 1 : -1;

        translateY =
          directionY * verticalInset * closed;

      }

      /*
        Very subtle scale effect.

        No large transforms or opacity
        reductions that could cause cards
        to stack into each other.
      */

      const scale = 0.98 + eased * 0.02;

      card.style.transform =
        `translate3d(
          ${translateX.toFixed(2)}px,
          ${translateY.toFixed(2)}px,
          0
        ) scale(${scale.toFixed(4)})`;

      card.style.opacity = '1';

    });

  }

  /* ==================================
     RENDER SECTION
  ================================== */

  function updateSection(section) {

    /*
      If animation is disabled in the
      customizer or the visitor prefers
      reduced motion, show final state.
    */

    const animationEnabled =
      section.dataset.enableAnimation !== 'false';

    const progress =
      !animationEnabled || reducedMotion.matches
        ? 1
        : getProgress(section);

    updateText(section, progress);
    updateCards(section, progress);

  }

  /* ==================================
     REQUEST A SINGLE FRAME
  ================================== */

  function render() {

    animationFrame = null;

    const sections = document.querySelectorAll(
      selector
    );

    sections.forEach(updateSection);

  }

  function scheduleRender() {

    if (animationFrame !== null) return;

    animationFrame =
      window.requestAnimationFrame(render);

  }

  /* ==================================
     INITIAL LOAD
  ================================== */

  if (document.readyState === 'loading') {

    document.addEventListener(
      'DOMContentLoaded',
      scheduleRender,
      { once: true }
    );

  } else {

    scheduleRender();

  }

  /* ==================================
     SCROLL AND RESIZE
  ================================== */

  window.addEventListener(
    'scroll',
    scheduleRender,
    { passive: true }
  );

  window.addEventListener(
    'resize',
    scheduleRender,
    { passive: true }
  );

  /* ==================================
     REDUCED MOTION
  ================================== */

  reducedMotion.addEventListener(
    'change',
    scheduleRender
  );

  /* ==================================
     SHOPIFY THEME EDITOR
  ================================== */

  document.addEventListener(
    'shopify:section:load',
    scheduleRender
  );

  document.addEventListener(
    'shopify:section:select',
    scheduleRender
  );

  document.addEventListener(
    'shopify:block:select',
    scheduleRender
  );

})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
